<div class="flex mb-20">
  <div *ngFor="let item of items; let last = last" class="flex flex-row items-center">
    <span *ngIf="!item.url" class="mat-caption">{{item.label}}</span>
    <a class="no-underline mr-8 mat-caption" *ngIf="item.url" [routerLink]="['/', tenant].concat(item.url)">{{item.label}}</a>
    <mat-icon svgIcon="chevron_right" *ngIf="!last" class="mr-8 icon-sm"></mat-icon>
  </div>
</div>
